import { Dayjs } from "dayjs"
import { DateOnly } from "../@client/System"

export const dayJstoDateOnly = (dayjs: Dayjs) =>
  dayjs.format("YYYY-MM-DD") as DateOnly

export const isFirstDayOfMonth = (dayjs: Dayjs) => dayjs.date() === 1
export const isLastDayOfMonth = (dayjs: Dayjs) =>
  dayjs.date() === dayjs.daysInMonth()
